// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   EXCHANGES DASHBOARD 
   ========================================================================== */

/* CSS Variables for Design System */
:root {
  /* Layout */
  --exchanges-max-width: 1250px;
  --exchanges-container-padding: 24px;
  --exchanges-grid-gap: 20px;
  --exchanges-border-radius: 8px;
  
  /* Colors */
  --exchanges-color-background: #ffffff;
  --exchanges-color-surface: #ffffff;
  --exchanges-color-border: #e1e5e9;
  --exchanges-color-border-light: #f0f0f0;
  
  /* Text Colors */
  --exchanges-color-text-primary: #1a202c;
  --exchanges-color-text-secondary: #718096;
  --exchanges-color-text-muted: #a0aec0;
  
  /* Accent Colors */
  --exchanges-color-accent: #3182ce;
  --exchanges-color-success: #38a169;
  --exchanges-color-error: #e53e3e;
  --exchanges-color-warning: #d69e2e;
  
  /* Interactive States */
  --exchanges-color-hover: #f8f9fa;
  --exchanges-color-active: #e2e8f0;
  
  /* Shadows */
  --exchanges-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);
  --exchanges-shadow-md: 0 4px 6px rgba(0, 0, 0, 0.07);
  --exchanges-shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
  
  /* Typography */
  --exchanges-font-family-base: 'Roboto Mono', 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
  --exchanges-font-family-mono: 'Roboto Mono', 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
  
  /* Font Sizes */
  --exchanges-font-size-xs: 12px;
  --exchanges-font-size-sm: 13px;
  --exchanges-font-size-base: 14px;
  --exchanges-font-size-lg: 16px;
  --exchanges-font-size-xl: 18px;
  --exchanges-font-size-2xl: 24px;
  
  /* Font Weights */
  --exchanges-font-weight-normal: 100;
  --exchanges-font-weight-medium: 200;
  --exchanges-font-weight-semibold: 200;
  --exchanges-font-weight-bold: 400;
  
  /* Transitions */
  --exchanges-transition-fast: 0.15s ease;
  --exchanges-transition-base: 0.2s ease;
  --exchanges-transition-slow: 0.3s ease;
}

/* ==========================================================================
   BASE STYLES & LAYOUT
   ========================================================================== */

/* Main container */
.exchanges-dashboard {
  width: 100%;
  max-width: var(--exchanges-max-width);
  margin: 0 auto;
  padding: var(--exchanges-container-padding);
  background-color: var(--exchanges-color-background);
  min-height: 100vh;
  font-family: var(--exchanges-font-family-base);
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Title */
.exchanges-title {
  font-size: var(--exchanges-font-size-2xl);
  font-weight: var(--exchanges-font-weight-semibold);
  color: var(--exchanges-color-text-primary);
  text-align: center;
  margin-bottom: 32px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--exchanges-color-border);
  width: 100%;
  max-width: 1200px;
}

/* Section styling */
.exchanges-section {
  width: 100%;
  max-width: 1200px;
  margin-bottom: 48px;
}

.exchanges-section-title {
  font-size: var(--exchanges-font-size-xl);
  font-weight: var(--exchanges-font-weight-semibold);
  color: var(--exchanges-color-text-primary);
  margin-bottom: 24px;
  padding-bottom: 8px;
  border-bottom: 2px solid var(--exchanges-color-border);
}

/* ==========================================================================
   CHART STYLES
   ========================================================================== */

.exchanges-chart-container {
  background: var(--exchanges-color-surface);
  border: 1px solid var(--exchanges-color-border);
  border-radius: var(--exchanges-border-radius);
  padding: 24px;
  margin-bottom: 32px;
  box-shadow: var(--exchanges-shadow-sm);
  transition: all var(--exchanges-transition-base);
}

.exchanges-chart-container:hover {
  box-shadow: var(--exchanges-shadow-md);
  transform: translateY(-1px);
}

/* Bar Chart Container - Separate styling */
.exchanges-bar-chart-container {
  background: var(--exchanges-color-surface);
  border: 1px solid var(--exchanges-color-border);
  border-radius: var(--exchanges-border-radius);
  padding: 24px;
  margin-bottom: 32px;
  box-shadow: var(--exchanges-shadow-sm);
  transition: all var(--exchanges-transition-base);
  height: auto;
  min-height: 500px;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
}

.exchanges-bar-chart-container:hover {
  box-shadow: var(--exchanges-shadow-md);
  transform: translateY(-1px);
}

.exchanges-chart-title {
  font-family: var(--exchanges-font-family-base);
  font-size: var(--exchanges-font-size-lg);
  font-weight: var(--exchanges-font-weight-medium);
  color: var(--exchanges-color-text-primary);
  margin: 0 0 16px 0;
  text-align: center;
}

/* Bar Chart Title - Separate styling */
.exchanges-bar-chart-title {
  font-family: var(--exchanges-font-family-base);
  font-size: var(--exchanges-font-size-lg);
  font-weight: var(--exchanges-font-weight-medium);
  color: var(--exchanges-color-text-primary);
  margin: 0 0 20px 0;
  text-align: center;
}

.exchanges-chart-wrapper {
  width: 100%;
  height: 400px;
  margin-bottom: 16px;
}

/* Bar Chart Wrapper - Separate styling */
.exchanges-bar-chart-wrapper {
  width: 100%;
  height: 400px;
  margin-bottom: 16px;
}

/* Chart controls */
.exchanges-chart-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 16px;
}

.exchanges-chart-type-buttons,
.exchanges-timeframe-buttons {
  display: flex;
  gap: 4px;
  padding: 4px;
  background: var(--exchanges-color-surface);
  border: 1px solid var(--exchanges-color-border);
  border-radius: var(--exchanges-border-radius);
  box-shadow: var(--exchanges-shadow-sm);
}

.exchanges-control-button {
  padding: 8px 16px;
  font-family: var(--exchanges-font-family-base);
  font-size: var(--exchanges-font-size-sm);
  font-weight: var(--exchanges-font-weight-medium);
  color: var(--exchanges-color-text-secondary);
  background: transparent;
  border: none;
  border-radius: calc(var(--exchanges-border-radius) - 2px);
  cursor: pointer;
  transition: all var(--exchanges-transition-fast);
  text-align: center;
}

.exchanges-control-button:hover {
  color: var(--exchanges-color-text-primary);
  background: var(--exchanges-color-hover);
}

.exchanges-control-button.active {
  color: var(--exchanges-color-accent);
  background: var(--exchanges-color-surface);
  box-shadow: var(--exchanges-shadow-sm);
  font-weight: var(--exchanges-font-weight-semibold);
}

/* Interactive legend */
.exchanges-interactive-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  padding: 16px;
  background: var(--exchanges-color-surface);
  border: 1px solid var(--exchanges-color-border-light);
  border-radius: var(--exchanges-border-radius);
  margin-top: 16px;
}

.exchanges-legend-all-button {
  padding: 6px 12px;
  font-family: var(--exchanges-font-family-base);
  font-size: var(--exchanges-font-size-sm);
  font-weight: var(--exchanges-font-weight-semibold);
  color: var(--exchanges-color-accent);
  background: var(--exchanges-color-surface);
  border: 1px solid var(--exchanges-color-accent);
  border-radius: var(--exchanges-border-radius);
  cursor: pointer;
  transition: all var(--exchanges-transition-fast);
}

.exchanges-legend-all-button:hover {
  background: var(--exchanges-color-accent);
  color: white;
}

.exchanges-legend-item {
  padding: 6px 12px;
  font-family: var(--exchanges-font-family-base);
  font-size: var(--exchanges-font-size-sm);
  font-weight: var(--exchanges-font-weight-medium);
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--exchanges-border-radius);
  cursor: pointer;
  transition: all var(--exchanges-transition-fast);
}

.exchanges-legend-item.active {
  background: var(--exchanges-color-hover);
  border-color: var(--exchanges-color-border);
}

.exchanges-legend-item.inactive {
  opacity: 0.5;
}

.exchanges-legend-item:hover {
  background: var(--exchanges-color-hover);
  border-color: var(--exchanges-color-border);
}

/* Modern Tooltip Styling for Charts */
.exchanges-chart-container .recharts-tooltip-wrapper {
  background: var(--exchanges-color-surface);
  border: 1px solid var(--exchanges-color-border);
  border-radius: var(--exchanges-border-radius);
  box-shadow: var(--exchanges-shadow-md);
  padding: 12px;
  font-family: var(--exchanges-font-family-base);
  font-size: var(--exchanges-font-size-sm);
}

.exchanges-chart-container .recharts-tooltip-item {
  color: var(--exchanges-color-text-primary);
  font-family: var(--exchanges-font-family-mono);
}

.exchanges-chart-container .recharts-tooltip-label {
  color: var(--exchanges-color-text-secondary);
  font-weight: var(--exchanges-font-weight-medium);
  margin-bottom: 8px;
}

/* Chart Text Styling */
.exchanges-chart-container .recharts-text {
  font-family: var(--exchanges-font-family-base);
  font-size: var(--exchanges-font-size-xs);
  fill: var(--exchanges-color-text-secondary);
}

.exchanges-bar-chart-container .recharts-text {
  font-family: var(--exchanges-font-family-base);
  font-size: var(--exchanges-font-size-xs);
  fill: var(--exchanges-color-text-secondary);
}

/* Custom tooltip */
.exchanges-custom-tooltip {
  background: rgba(255, 255, 255, 0.95);
  border: none;
  border-radius: var(--exchanges-border-radius);
  padding: 8px 12px;
  font-size: var(--exchanges-font-size-sm);
  font-family: var(--exchanges-font-family-base);
}

.exchanges-tooltip-label {
  margin: 0 0 4px 0;
  color: var(--exchanges-color-text-secondary);
  font-weight: var(--exchanges-font-weight-medium);
}

.exchanges-tooltip-item {
  margin: 4px 0 0 0;
  font-weight: var(--exchanges-font-weight-medium);
  font-family: var(--exchanges-font-family-mono);
}

/* ==========================================================================
   TABLE STYLES
   ========================================================================== */

.exchanges-table-container {
  background: var(--exchanges-color-surface);
  border: 1px solid var(--exchanges-color-border);
  border-radius: var(--exchanges-border-radius);
  padding: 0;
  margin-bottom: 32px;
  box-shadow: var(--exchanges-shadow-sm);
  transition: all var(--exchanges-transition-base);
  overflow: hidden;
}

.exchanges-table-container:hover {
  box-shadow: var(--exchanges-shadow-md);
}

.exchanges-table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 20px 24px;
  background: #f5f7fa;
  border-bottom: 1px solid var(--exchanges-color-border);
}

.exchanges-table-header h3 {
  font-family: var(--exchanges-font-family-base);
  font-size: var(--exchanges-font-size-lg);
  font-weight: var(--exchanges-font-weight-semibold) !important;
  color: var(--exchanges-color-text-primary);
  margin: 0;
}

.exchanges-table-filter {
  padding: 8px 12px;
  font-family: var(--exchanges-font-family-base);
  font-size: var(--exchanges-font-size-sm);
  border: 1px solid var(--exchanges-color-border);
  border-radius: var(--exchanges-border-radius);
  background: var(--exchanges-color-surface);
  color: var(--exchanges-color-text-primary);
  transition: border-color var(--exchanges-transition-fast);
  width: 200px;
}

.exchanges-table-filter:focus {
  outline: none;
  border-color: var(--exchanges-color-accent);
}

.exchanges-table-wrapper {
  overflow-x: auto;
  border-radius: 0;
}

.exchanges-table {
  width: 100%;
  border-collapse: collapse;
  font-family: var(--exchanges-font-family-base);
  font-size: var(--exchanges-font-size-sm);
}

.exchanges-table thead th {
  background: white;
  color: var(--exchanges-color-text-primary);
  font-family: var(--exchanges-font-family-base);
  font-size: var(--exchanges-font-size-sm);
  font-weight: var(--exchanges-font-weight-medium) !important;
  padding: 16px;
  text-align: right;
  border-bottom: 1px solid var(--exchanges-color-border);
  white-space: nowrap;
  cursor: pointer;
  transition: background-color var(--exchanges-transition-fast);
  position: sticky;
  top: 0;
  z-index: 10;
}

.exchanges-table thead th:first-child {
  text-align: left;
}

.exchanges-table thead th.exchanges-sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color var(--exchanges-transition-fast);
}

.exchanges-table thead th:hover {
  background: #edf2f7;
}

.exchanges-table tbody td {
  padding: 16px;
  text-align: right;
  border-bottom: 1px solid var(--exchanges-color-border-light);
  font-family: var(--exchanges-font-family-mono);
  font-size: var(--exchanges-font-size-sm);
  color: var(--exchanges-color-text-primary);
  transition: all var(--exchanges-transition-base);
  min-height: 48px;
  vertical-align: middle;
}

.exchanges-table tbody tr {
  opacity: 1;
  transform: translateY(0);
  transition: all var(--exchanges-transition-slow), 
              opacity var(--exchanges-transition-base), 
              transform var(--exchanges-transition-base),
              max-height var(--exchanges-transition-slow);
  max-height: 200px;
  overflow: hidden;
}

.exchanges-table tbody tr.filtering-out {
  opacity: 0;
  transform: translateY(-10px);
  max-height: 0;
  padding: 0;
  margin: 0;
}

.exchanges-table tbody tr.filtering-in {
  animation: filterIn var(--exchanges-transition-slow) ease-out;
}

@keyframes filterIn {
  from {
    opacity: 0;
    transform: translateY(10px);
    max-height: 0;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    max-height: 200px;
  }
}

.exchanges-table tbody td:first-child {
  text-align: left;
  font-family: var(--exchanges-font-family-base);
  font-weight: var(--exchanges-font-weight-medium) !important;
}

.exchanges-table tbody tr:nth-child(even) {
  background: #f9f9f9;
}

.exchanges-table tbody tr:hover {
  background: var(--exchanges-color-hover);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.exchanges-table tbody tr:last-child td {
  border-bottom: none;
}

.exchanges-sort-indicator {
  font-family: var(--exchanges-font-family-mono);
  font-size: var(--exchanges-font-size-xs);
  margin-left: 4px;
  color: var(--exchanges-color-accent);
}

/* ==========================================================================
   LOADING & ERROR STATES
   ========================================================================== */

.exchanges-loading,
.exchanges-error {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  font-family: var(--exchanges-font-family-base);
  font-size: var(--exchanges-font-size-lg);
  font-weight: var(--exchanges-font-weight-medium);
}

.exchanges-loading {
  color: var(--exchanges-color-text-secondary);
}

.exchanges-error {
  color: var(--exchanges-color-error);
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: var(--exchanges-border-radius);
  padding: 24px;
}

/* ==========================================================================
   RESPONSIVE DESIGN
   ========================================================================== */

@media (max-width: 1200px) {
  .exchanges-dashboard {
    padding: 16px;
  }
}

@media (max-width: 768px) {
  :root {
    --exchanges-container-padding: 16px;
  }

  .exchanges-dashboard {
    padding: var(--exchanges-container-padding);
  }

  .exchanges-title {
    font-size: var(--exchanges-font-size-xl);
    margin-bottom: 24px;
  }

  .exchanges-chart-controls {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .exchanges-chart-type-buttons,
  .exchanges-timeframe-buttons {
    justify-content: center;
  }

  .exchanges-chart-container,
  .exchanges-table-container {
    padding: 16px;
  }

  .exchanges-bar-chart-container {
    padding: 16px;
  }

  .exchanges-table thead th,
  .exchanges-table tbody td {
    padding: 12px 8px;
    font-size: var(--exchanges-font-size-xs);
  }

  .exchanges-table-header {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 16px;
  }

  .exchanges-table-filter {
    width: 100%;
  }

  .exchanges-interactive-legend {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .exchanges-chart-container,
  .exchanges-table-container {
    padding: 12px;
    margin-bottom: 24px;
  }

  .exchanges-bar-chart-container {
    padding: 12px;
    margin-bottom: 24px;
    height: auto;
    min-height: 350px;
  }

  .exchanges-table thead th,
  .exchanges-table tbody td {
    padding: 8px 4px;
  }

  .exchanges-table-header {
    padding: 12px;
  }

  .exchanges-control-button {
    padding: 6px 12px;
    font-size: var(--exchanges-font-size-xs);
  }
}

/* ==========================================================================
   UTILITY CLASSES
   ========================================================================== */

.exchanges-text-center {
  text-align: center;
}

.exchanges-text-right {
  text-align: right;
}

.exchanges-text-left {
  text-align: left;
}

.exchanges-font-mono {
  font-family: var(--exchanges-font-family-mono);
}

.exchanges-font-medium {
  font-weight: var(--exchanges-font-weight-medium);
}

.exchanges-font-semibold {
  font-weight: var(--exchanges-font-weight-semibold);
}

.exchanges-text-muted {
  color: var(--exchanges-color-text-muted);
}

.exchanges-text-secondary {
  color: var(--exchanges-color-text-secondary);
}

.exchanges-mb-0 {
  margin-bottom: 0;
}

.exchanges-mb-2 {
  margin-bottom: 8px;
}

.exchanges-mb-4 {
  margin-bottom: 16px;
}

.exchanges-mb-6 {
  margin-bottom: 24px;
}

.exchanges-p-0 {
  padding: 0;
}

.exchanges-p-2 {
  padding: 8px;
}

.exchanges-p-4 {
  padding: 16px;
}

.exchanges-p-6 {
  padding: 24px;
}

/* ==========================================================================
   MULTI-SELECT FILTER COMPONENTS
   ========================================================================== */

.exchanges-multi-select-filter {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 225px;
}

.exchanges-filter-input-container {
  position: relative;
  width: 100%;
}

.exchanges-filter-suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--exchanges-color-surface);
  border-top: none;
  border-radius: 0 0 var(--exchanges-border-radius) var(--exchanges-border-radius);
  box-shadow: var(--exchanges-shadow-md);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
}

.exchanges-filter-suggestion {
  display: block;
  width: 100%;
  padding: 8px 12px;
  font-family: var(--exchanges-font-family-base);
  font-size: var(--exchanges-font-size-sm);
  color: var(--exchanges-color-text-primary);
  background: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
  transition: background-color var(--exchanges-transition-fast);
}

.exchanges-filter-suggestion:hover {
  background: var(--exchanges-color-hover);
}

.exchanges-filter-suggestion:first-child {
  border-radius: 0;
}

.exchanges-filter-suggestion:last-child {
  border-radius: 0 0 var(--exchanges-border-radius) var(--exchanges-border-radius);
}

.exchanges-selected-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-top: 2px;
  padding: 0px;
}

.exchanges-filter-tag {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 6px 8px 6px 12px;
  font-family: var(--exchanges-font-family-base);
  font-size: var(--exchanges-font-size-sm);
  font-weight: var(--exchanges-font-weight-medium);
  color: var(--exchanges-color-text-primary);
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  transition: all var(--exchanges-transition-fast);
}

.exchanges-filter-tag:hover {
  background: white;
  border-color: #cbd5e1;
}

.exchanges-filter-remove {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  font-family: var(--exchanges-font-family-base);
  font-size: 14px;
  font-weight: var(--exchanges-font-weight-bold);
  color: var(--exchanges-color-text-muted);
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all var(--exchanges-transition-fast);
  line-height: 1;
  padding: 0;
}

.exchanges-filter-remove:hover {
  color: var(--exchanges-color-error);
  background: rgba(239, 68, 68, 0.1);
}

.exchanges-filter-remove:active {
  transform: scale(0.95);
}

/* Enhanced focus states */
.exchanges-table-filter:focus + .exchanges-filter-suggestions {
  border-color: var(--exchanges-color-accent);
}

/* Responsive adjustments for filter */
@media (max-width: 768px) {
  .exchanges-multi-select-filter {
    max-width: 100%;
  }
  
  .exchanges-filter-tag {
    font-size: var(--exchanges-font-size-xs);
    padding: 4px 6px 4px 8px;
  }
  
  .exchanges-filter-remove {
    width: 16px;
    height: 16px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .exchanges-selected-filters {
    gap: 6px;
  }
  
  .exchanges-filter-tag {
    padding: 3px 5px 3px 7px;
  }
  
  .exchanges-filter-remove {
    width: 14px;
    height: 14px;
    font-size: 11px;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/exchanges.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E,oCAAoC;AACpC;EACE,WAAW;EACX,6BAA6B;EAC7B,mCAAmC;EACnC,0BAA0B;EAC1B,8BAA8B;;EAE9B,WAAW;EACX,qCAAqC;EACrC,kCAAkC;EAClC,iCAAiC;EACjC,uCAAuC;;EAEvC,gBAAgB;EAChB,uCAAuC;EACvC,yCAAyC;EACzC,qCAAqC;;EAErC,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,gCAAgC;EAChC,kCAAkC;;EAElC,uBAAuB;EACvB,gCAAgC;EAChC,iCAAiC;;EAEjC,YAAY;EACZ,mDAAmD;EACnD,oDAAoD;EACpD,qDAAqD;;EAErD,eAAe;EACf,kIAAkI;EAClI,kIAAkI;;EAElI,eAAe;EACf,8BAA8B;EAC9B,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;;EAE/B,iBAAiB;EACjB,mCAAmC;EACnC,mCAAmC;EACnC,qCAAqC;EACrC,iCAAiC;;EAEjC,gBAAgB;EAChB,uCAAuC;EACvC,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;;+EAE+E;;AAE/E,mBAAmB;AACnB;EACE,WAAW;EACX,qCAAqC;EACrC,cAAc;EACd,2CAA2C;EAC3C,mDAAmD;EACnD,iBAAiB;EACjB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,yCAAyC;EACzC,kDAAkD;EAClD,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,sDAAsD;EACtD,WAAW;EACX,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,kDAAkD;EAClD,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;;+EAE+E;;AAE/E;EACE,0CAA0C;EAC1C,+CAA+C;EAC/C,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,2CAA2C;AAC3C;EACE,0CAA0C;EAC1C,+CAA+C;EAC/C,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,gDAAgD;EAChD,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,gDAAgD;EAChD,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,gDAAgD;EAChD,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,0CAA0C;EAC1C,+CAA+C;EAC/C,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,wCAAwC;EACxC,gDAAgD;EAChD,4CAA4C;EAC5C,uBAAuB;EACvB,YAAY;EACZ,yDAAyD;EACzD,eAAe;EACf,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,sCAAsC;EACtC,kDAAkD;AACpD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,qDAAqD;EACrD,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,wCAAwC;EACxC,kDAAkD;EAClD,oCAAoC;EACpC,0CAA0C;EAC1C,+CAA+C;EAC/C,6CAA6C;EAC7C,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,wCAAwC;EACxC,gDAAgD;EAChD,uBAAuB;EACvB,6BAA6B;EAC7B,6CAA6C;EAC7C,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA,sCAAsC;AACtC;EACE,0CAA0C;EAC1C,+CAA+C;EAC/C,6CAA6C;EAC7C,sCAAsC;EACtC,aAAa;EACb,8CAA8C;EAC9C,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA;EACE,4CAA4C;EAC5C,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA,mBAAmB;AACnB;EACE,qCAAqC;EACrC,YAAY;EACZ,6CAA6C;EAC7C,iBAAiB;EACjB,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,gDAAgD;EAChD,8CAA8C;AAChD;;AAEA;;+EAE+E;;AAE/E;EACE,0CAA0C;EAC1C,+CAA+C;EAC/C,6CAA6C;EAC7C,UAAU;EACV,mBAAmB;EACnB,sCAAsC;EACtC,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,6DAA6D;EAC7D,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,wCAAwC;EACxC,+CAA+C;EAC/C,6CAA6C;EAC7C,0CAA0C;EAC1C,0CAA0C;EAC1C,yDAAyD;EACzD,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,8CAA8C;EAC9C,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,8CAA8C;EAC9C,wCAAwC;EACxC,2DAA2D;EAC3D,aAAa;EACb,iBAAiB;EACjB,sDAAsD;EACtD,mBAAmB;EACnB,eAAe;EACf,6DAA6D;EAC7D,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,4DAA4D;EAC5D,8CAA8C;EAC9C,wCAAwC;EACxC,0CAA0C;EAC1C,gDAAgD;EAChD,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB;;;yDAGuD;EACvD,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,aAAa;EACb,UAAU;EACV,SAAS;AACX;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;IAC3B,aAAa;EACf;EACA;IACE,UAAU;IACV,wBAAwB;IACxB,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;;+EAE+E;;AAE/E;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,8CAA8C;EAC9C,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;;+EAE+E;;AAE/E;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,wCAAwC;IACxC,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;IACjB,wCAAwC;EAC1C;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;;IAEE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,wCAAwC;EAC1C;AACF;;AAEA;;+EAE+E;;AAE/E;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,0CAA0C;EAC1C,gBAAgB;EAChB,gFAAgF;EAChF,sCAAsC;EACtC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,8CAA8C;EAC9C,wCAAwC;EACxC,0CAA0C;EAC1C,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gFAAgF;AAClF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,8CAA8C;EAC9C,wCAAwC;EACxC,gDAAgD;EAChD,0CAA0C;EAC1C,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,eAAe;EACf,8CAA8C;EAC9C,wCAAwC;EACxC,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gDAAgD;EAChD,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,2CAA2C;AAC7C;;AAEA,sCAAsC;AACtC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,wCAAwC;IACxC,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":["/* ==========================================================================\n   EXCHANGES DASHBOARD \n   ========================================================================== */\n\n/* CSS Variables for Design System */\n:root {\n  /* Layout */\n  --exchanges-max-width: 1250px;\n  --exchanges-container-padding: 24px;\n  --exchanges-grid-gap: 20px;\n  --exchanges-border-radius: 8px;\n  \n  /* Colors */\n  --exchanges-color-background: #ffffff;\n  --exchanges-color-surface: #ffffff;\n  --exchanges-color-border: #e1e5e9;\n  --exchanges-color-border-light: #f0f0f0;\n  \n  /* Text Colors */\n  --exchanges-color-text-primary: #1a202c;\n  --exchanges-color-text-secondary: #718096;\n  --exchanges-color-text-muted: #a0aec0;\n  \n  /* Accent Colors */\n  --exchanges-color-accent: #3182ce;\n  --exchanges-color-success: #38a169;\n  --exchanges-color-error: #e53e3e;\n  --exchanges-color-warning: #d69e2e;\n  \n  /* Interactive States */\n  --exchanges-color-hover: #f8f9fa;\n  --exchanges-color-active: #e2e8f0;\n  \n  /* Shadows */\n  --exchanges-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);\n  --exchanges-shadow-md: 0 4px 6px rgba(0, 0, 0, 0.07);\n  --exchanges-shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);\n  \n  /* Typography */\n  --exchanges-font-family-base: 'Roboto Mono', 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;\n  --exchanges-font-family-mono: 'Roboto Mono', 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;\n  \n  /* Font Sizes */\n  --exchanges-font-size-xs: 12px;\n  --exchanges-font-size-sm: 13px;\n  --exchanges-font-size-base: 14px;\n  --exchanges-font-size-lg: 16px;\n  --exchanges-font-size-xl: 18px;\n  --exchanges-font-size-2xl: 24px;\n  \n  /* Font Weights */\n  --exchanges-font-weight-normal: 100;\n  --exchanges-font-weight-medium: 200;\n  --exchanges-font-weight-semibold: 200;\n  --exchanges-font-weight-bold: 400;\n  \n  /* Transitions */\n  --exchanges-transition-fast: 0.15s ease;\n  --exchanges-transition-base: 0.2s ease;\n  --exchanges-transition-slow: 0.3s ease;\n}\n\n/* ==========================================================================\n   BASE STYLES & LAYOUT\n   ========================================================================== */\n\n/* Main container */\n.exchanges-dashboard {\n  width: 100%;\n  max-width: var(--exchanges-max-width);\n  margin: 0 auto;\n  padding: var(--exchanges-container-padding);\n  background-color: var(--exchanges-color-background);\n  min-height: 100vh;\n  font-family: var(--exchanges-font-family-base);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Title */\n.exchanges-title {\n  font-size: var(--exchanges-font-size-2xl);\n  font-weight: var(--exchanges-font-weight-semibold);\n  color: var(--exchanges-color-text-primary);\n  text-align: center;\n  margin-bottom: 32px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--exchanges-color-border);\n  width: 100%;\n  max-width: 1200px;\n}\n\n/* Section styling */\n.exchanges-section {\n  width: 100%;\n  max-width: 1200px;\n  margin-bottom: 48px;\n}\n\n.exchanges-section-title {\n  font-size: var(--exchanges-font-size-xl);\n  font-weight: var(--exchanges-font-weight-semibold);\n  color: var(--exchanges-color-text-primary);\n  margin-bottom: 24px;\n  padding-bottom: 8px;\n  border-bottom: 2px solid var(--exchanges-color-border);\n}\n\n/* ==========================================================================\n   CHART STYLES\n   ========================================================================== */\n\n.exchanges-chart-container {\n  background: var(--exchanges-color-surface);\n  border: 1px solid var(--exchanges-color-border);\n  border-radius: var(--exchanges-border-radius);\n  padding: 24px;\n  margin-bottom: 32px;\n  box-shadow: var(--exchanges-shadow-sm);\n  transition: all var(--exchanges-transition-base);\n}\n\n.exchanges-chart-container:hover {\n  box-shadow: var(--exchanges-shadow-md);\n  transform: translateY(-1px);\n}\n\n/* Bar Chart Container - Separate styling */\n.exchanges-bar-chart-container {\n  background: var(--exchanges-color-surface);\n  border: 1px solid var(--exchanges-color-border);\n  border-radius: var(--exchanges-border-radius);\n  padding: 24px;\n  margin-bottom: 32px;\n  box-shadow: var(--exchanges-shadow-sm);\n  transition: all var(--exchanges-transition-base);\n  height: auto;\n  min-height: 500px;\n  max-width: 1200px;\n  display: flex;\n  flex-direction: column;\n}\n\n.exchanges-bar-chart-container:hover {\n  box-shadow: var(--exchanges-shadow-md);\n  transform: translateY(-1px);\n}\n\n.exchanges-chart-title {\n  font-family: var(--exchanges-font-family-base);\n  font-size: var(--exchanges-font-size-lg);\n  font-weight: var(--exchanges-font-weight-medium);\n  color: var(--exchanges-color-text-primary);\n  margin: 0 0 16px 0;\n  text-align: center;\n}\n\n/* Bar Chart Title - Separate styling */\n.exchanges-bar-chart-title {\n  font-family: var(--exchanges-font-family-base);\n  font-size: var(--exchanges-font-size-lg);\n  font-weight: var(--exchanges-font-weight-medium);\n  color: var(--exchanges-color-text-primary);\n  margin: 0 0 20px 0;\n  text-align: center;\n}\n\n.exchanges-chart-wrapper {\n  width: 100%;\n  height: 400px;\n  margin-bottom: 16px;\n}\n\n/* Bar Chart Wrapper - Separate styling */\n.exchanges-bar-chart-wrapper {\n  width: 100%;\n  height: 400px;\n  margin-bottom: 16px;\n}\n\n/* Chart controls */\n.exchanges-chart-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  gap: 16px;\n}\n\n.exchanges-chart-type-buttons,\n.exchanges-timeframe-buttons {\n  display: flex;\n  gap: 4px;\n  padding: 4px;\n  background: var(--exchanges-color-surface);\n  border: 1px solid var(--exchanges-color-border);\n  border-radius: var(--exchanges-border-radius);\n  box-shadow: var(--exchanges-shadow-sm);\n}\n\n.exchanges-control-button {\n  padding: 8px 16px;\n  font-family: var(--exchanges-font-family-base);\n  font-size: var(--exchanges-font-size-sm);\n  font-weight: var(--exchanges-font-weight-medium);\n  color: var(--exchanges-color-text-secondary);\n  background: transparent;\n  border: none;\n  border-radius: calc(var(--exchanges-border-radius) - 2px);\n  cursor: pointer;\n  transition: all var(--exchanges-transition-fast);\n  text-align: center;\n}\n\n.exchanges-control-button:hover {\n  color: var(--exchanges-color-text-primary);\n  background: var(--exchanges-color-hover);\n}\n\n.exchanges-control-button.active {\n  color: var(--exchanges-color-accent);\n  background: var(--exchanges-color-surface);\n  box-shadow: var(--exchanges-shadow-sm);\n  font-weight: var(--exchanges-font-weight-semibold);\n}\n\n/* Interactive legend */\n.exchanges-interactive-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  padding: 16px;\n  background: var(--exchanges-color-surface);\n  border: 1px solid var(--exchanges-color-border-light);\n  border-radius: var(--exchanges-border-radius);\n  margin-top: 16px;\n}\n\n.exchanges-legend-all-button {\n  padding: 6px 12px;\n  font-family: var(--exchanges-font-family-base);\n  font-size: var(--exchanges-font-size-sm);\n  font-weight: var(--exchanges-font-weight-semibold);\n  color: var(--exchanges-color-accent);\n  background: var(--exchanges-color-surface);\n  border: 1px solid var(--exchanges-color-accent);\n  border-radius: var(--exchanges-border-radius);\n  cursor: pointer;\n  transition: all var(--exchanges-transition-fast);\n}\n\n.exchanges-legend-all-button:hover {\n  background: var(--exchanges-color-accent);\n  color: white;\n}\n\n.exchanges-legend-item {\n  padding: 6px 12px;\n  font-family: var(--exchanges-font-family-base);\n  font-size: var(--exchanges-font-size-sm);\n  font-weight: var(--exchanges-font-weight-medium);\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: var(--exchanges-border-radius);\n  cursor: pointer;\n  transition: all var(--exchanges-transition-fast);\n}\n\n.exchanges-legend-item.active {\n  background: var(--exchanges-color-hover);\n  border-color: var(--exchanges-color-border);\n}\n\n.exchanges-legend-item.inactive {\n  opacity: 0.5;\n}\n\n.exchanges-legend-item:hover {\n  background: var(--exchanges-color-hover);\n  border-color: var(--exchanges-color-border);\n}\n\n/* Modern Tooltip Styling for Charts */\n.exchanges-chart-container .recharts-tooltip-wrapper {\n  background: var(--exchanges-color-surface);\n  border: 1px solid var(--exchanges-color-border);\n  border-radius: var(--exchanges-border-radius);\n  box-shadow: var(--exchanges-shadow-md);\n  padding: 12px;\n  font-family: var(--exchanges-font-family-base);\n  font-size: var(--exchanges-font-size-sm);\n}\n\n.exchanges-chart-container .recharts-tooltip-item {\n  color: var(--exchanges-color-text-primary);\n  font-family: var(--exchanges-font-family-mono);\n}\n\n.exchanges-chart-container .recharts-tooltip-label {\n  color: var(--exchanges-color-text-secondary);\n  font-weight: var(--exchanges-font-weight-medium);\n  margin-bottom: 8px;\n}\n\n/* Chart Text Styling */\n.exchanges-chart-container .recharts-text {\n  font-family: var(--exchanges-font-family-base);\n  font-size: var(--exchanges-font-size-xs);\n  fill: var(--exchanges-color-text-secondary);\n}\n\n.exchanges-bar-chart-container .recharts-text {\n  font-family: var(--exchanges-font-family-base);\n  font-size: var(--exchanges-font-size-xs);\n  fill: var(--exchanges-color-text-secondary);\n}\n\n/* Custom tooltip */\n.exchanges-custom-tooltip {\n  background: rgba(255, 255, 255, 0.95);\n  border: none;\n  border-radius: var(--exchanges-border-radius);\n  padding: 8px 12px;\n  font-size: var(--exchanges-font-size-sm);\n  font-family: var(--exchanges-font-family-base);\n}\n\n.exchanges-tooltip-label {\n  margin: 0 0 4px 0;\n  color: var(--exchanges-color-text-secondary);\n  font-weight: var(--exchanges-font-weight-medium);\n}\n\n.exchanges-tooltip-item {\n  margin: 4px 0 0 0;\n  font-weight: var(--exchanges-font-weight-medium);\n  font-family: var(--exchanges-font-family-mono);\n}\n\n/* ==========================================================================\n   TABLE STYLES\n   ========================================================================== */\n\n.exchanges-table-container {\n  background: var(--exchanges-color-surface);\n  border: 1px solid var(--exchanges-color-border);\n  border-radius: var(--exchanges-border-radius);\n  padding: 0;\n  margin-bottom: 32px;\n  box-shadow: var(--exchanges-shadow-sm);\n  transition: all var(--exchanges-transition-base);\n  overflow: hidden;\n}\n\n.exchanges-table-container:hover {\n  box-shadow: var(--exchanges-shadow-md);\n}\n\n.exchanges-table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0;\n  padding: 20px 24px;\n  background: #f5f7fa;\n  border-bottom: 1px solid var(--exchanges-color-border);\n}\n\n.exchanges-table-header h3 {\n  font-family: var(--exchanges-font-family-base);\n  font-size: var(--exchanges-font-size-lg);\n  font-weight: var(--exchanges-font-weight-semibold) !important;\n  color: var(--exchanges-color-text-primary);\n  margin: 0;\n}\n\n.exchanges-table-filter {\n  padding: 8px 12px;\n  font-family: var(--exchanges-font-family-base);\n  font-size: var(--exchanges-font-size-sm);\n  border: 1px solid var(--exchanges-color-border);\n  border-radius: var(--exchanges-border-radius);\n  background: var(--exchanges-color-surface);\n  color: var(--exchanges-color-text-primary);\n  transition: border-color var(--exchanges-transition-fast);\n  width: 200px;\n}\n\n.exchanges-table-filter:focus {\n  outline: none;\n  border-color: var(--exchanges-color-accent);\n}\n\n.exchanges-table-wrapper {\n  overflow-x: auto;\n  border-radius: 0;\n}\n\n.exchanges-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: var(--exchanges-font-family-base);\n  font-size: var(--exchanges-font-size-sm);\n}\n\n.exchanges-table thead th {\n  background: white;\n  color: var(--exchanges-color-text-primary);\n  font-family: var(--exchanges-font-family-base);\n  font-size: var(--exchanges-font-size-sm);\n  font-weight: var(--exchanges-font-weight-medium) !important;\n  padding: 16px;\n  text-align: right;\n  border-bottom: 1px solid var(--exchanges-color-border);\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color var(--exchanges-transition-fast);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.exchanges-table thead th:first-child {\n  text-align: left;\n}\n\n.exchanges-table thead th.exchanges-sortable {\n  cursor: pointer;\n  user-select: none;\n  transition: background-color var(--exchanges-transition-fast);\n}\n\n.exchanges-table thead th:hover {\n  background: #edf2f7;\n}\n\n.exchanges-table tbody td {\n  padding: 16px;\n  text-align: right;\n  border-bottom: 1px solid var(--exchanges-color-border-light);\n  font-family: var(--exchanges-font-family-mono);\n  font-size: var(--exchanges-font-size-sm);\n  color: var(--exchanges-color-text-primary);\n  transition: all var(--exchanges-transition-base);\n  min-height: 48px;\n  vertical-align: middle;\n}\n\n.exchanges-table tbody tr {\n  opacity: 1;\n  transform: translateY(0);\n  transition: all var(--exchanges-transition-slow), \n              opacity var(--exchanges-transition-base), \n              transform var(--exchanges-transition-base),\n              max-height var(--exchanges-transition-slow);\n  max-height: 200px;\n  overflow: hidden;\n}\n\n.exchanges-table tbody tr.filtering-out {\n  opacity: 0;\n  transform: translateY(-10px);\n  max-height: 0;\n  padding: 0;\n  margin: 0;\n}\n\n.exchanges-table tbody tr.filtering-in {\n  animation: filterIn var(--exchanges-transition-slow) ease-out;\n}\n\n@keyframes filterIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n    max-height: 0;\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n    max-height: 200px;\n  }\n}\n\n.exchanges-table tbody td:first-child {\n  text-align: left;\n  font-family: var(--exchanges-font-family-base);\n  font-weight: var(--exchanges-font-weight-medium) !important;\n}\n\n.exchanges-table tbody tr:nth-child(even) {\n  background: #f9f9f9;\n}\n\n.exchanges-table tbody tr:hover {\n  background: var(--exchanges-color-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.exchanges-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.exchanges-sort-indicator {\n  font-family: var(--exchanges-font-family-mono);\n  font-size: var(--exchanges-font-size-xs);\n  margin-left: 4px;\n  color: var(--exchanges-color-accent);\n}\n\n/* ==========================================================================\n   LOADING & ERROR STATES\n   ========================================================================== */\n\n.exchanges-loading,\n.exchanges-error {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  font-family: var(--exchanges-font-family-base);\n  font-size: var(--exchanges-font-size-lg);\n  font-weight: var(--exchanges-font-weight-medium);\n}\n\n.exchanges-loading {\n  color: var(--exchanges-color-text-secondary);\n}\n\n.exchanges-error {\n  color: var(--exchanges-color-error);\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: var(--exchanges-border-radius);\n  padding: 24px;\n}\n\n/* ==========================================================================\n   RESPONSIVE DESIGN\n   ========================================================================== */\n\n@media (max-width: 1200px) {\n  .exchanges-dashboard {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  :root {\n    --exchanges-container-padding: 16px;\n  }\n\n  .exchanges-dashboard {\n    padding: var(--exchanges-container-padding);\n  }\n\n  .exchanges-title {\n    font-size: var(--exchanges-font-size-xl);\n    margin-bottom: 24px;\n  }\n\n  .exchanges-chart-controls {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .exchanges-chart-type-buttons,\n  .exchanges-timeframe-buttons {\n    justify-content: center;\n  }\n\n  .exchanges-chart-container,\n  .exchanges-table-container {\n    padding: 16px;\n  }\n\n  .exchanges-bar-chart-container {\n    padding: 16px;\n  }\n\n  .exchanges-table thead th,\n  .exchanges-table tbody td {\n    padding: 12px 8px;\n    font-size: var(--exchanges-font-size-xs);\n  }\n\n  .exchanges-table-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n    padding: 16px;\n  }\n\n  .exchanges-table-filter {\n    width: 100%;\n  }\n\n  .exchanges-interactive-legend {\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .exchanges-chart-container,\n  .exchanges-table-container {\n    padding: 12px;\n    margin-bottom: 24px;\n  }\n\n  .exchanges-bar-chart-container {\n    padding: 12px;\n    margin-bottom: 24px;\n    height: auto;\n    min-height: 350px;\n  }\n\n  .exchanges-table thead th,\n  .exchanges-table tbody td {\n    padding: 8px 4px;\n  }\n\n  .exchanges-table-header {\n    padding: 12px;\n  }\n\n  .exchanges-control-button {\n    padding: 6px 12px;\n    font-size: var(--exchanges-font-size-xs);\n  }\n}\n\n/* ==========================================================================\n   UTILITY CLASSES\n   ========================================================================== */\n\n.exchanges-text-center {\n  text-align: center;\n}\n\n.exchanges-text-right {\n  text-align: right;\n}\n\n.exchanges-text-left {\n  text-align: left;\n}\n\n.exchanges-font-mono {\n  font-family: var(--exchanges-font-family-mono);\n}\n\n.exchanges-font-medium {\n  font-weight: var(--exchanges-font-weight-medium);\n}\n\n.exchanges-font-semibold {\n  font-weight: var(--exchanges-font-weight-semibold);\n}\n\n.exchanges-text-muted {\n  color: var(--exchanges-color-text-muted);\n}\n\n.exchanges-text-secondary {\n  color: var(--exchanges-color-text-secondary);\n}\n\n.exchanges-mb-0 {\n  margin-bottom: 0;\n}\n\n.exchanges-mb-2 {\n  margin-bottom: 8px;\n}\n\n.exchanges-mb-4 {\n  margin-bottom: 16px;\n}\n\n.exchanges-mb-6 {\n  margin-bottom: 24px;\n}\n\n.exchanges-p-0 {\n  padding: 0;\n}\n\n.exchanges-p-2 {\n  padding: 8px;\n}\n\n.exchanges-p-4 {\n  padding: 16px;\n}\n\n.exchanges-p-6 {\n  padding: 24px;\n}\n\n/* ==========================================================================\n   MULTI-SELECT FILTER COMPONENTS\n   ========================================================================== */\n\n.exchanges-multi-select-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  max-width: 225px;\n}\n\n.exchanges-filter-input-container {\n  position: relative;\n  width: 100%;\n}\n\n.exchanges-filter-suggestions {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: var(--exchanges-color-surface);\n  border-top: none;\n  border-radius: 0 0 var(--exchanges-border-radius) var(--exchanges-border-radius);\n  box-shadow: var(--exchanges-shadow-md);\n  z-index: 1000;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.exchanges-filter-suggestion {\n  display: block;\n  width: 100%;\n  padding: 8px 12px;\n  font-family: var(--exchanges-font-family-base);\n  font-size: var(--exchanges-font-size-sm);\n  color: var(--exchanges-color-text-primary);\n  background: transparent;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color var(--exchanges-transition-fast);\n}\n\n.exchanges-filter-suggestion:hover {\n  background: var(--exchanges-color-hover);\n}\n\n.exchanges-filter-suggestion:first-child {\n  border-radius: 0;\n}\n\n.exchanges-filter-suggestion:last-child {\n  border-radius: 0 0 var(--exchanges-border-radius) var(--exchanges-border-radius);\n}\n\n.exchanges-selected-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  margin-top: 2px;\n  padding: 0px;\n}\n\n.exchanges-filter-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 6px 8px 6px 12px;\n  font-family: var(--exchanges-font-family-base);\n  font-size: var(--exchanges-font-size-sm);\n  font-weight: var(--exchanges-font-weight-medium);\n  color: var(--exchanges-color-text-primary);\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  transition: all var(--exchanges-transition-fast);\n}\n\n.exchanges-filter-tag:hover {\n  background: white;\n  border-color: #cbd5e1;\n}\n\n.exchanges-filter-remove {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  font-family: var(--exchanges-font-family-base);\n  font-size: 14px;\n  font-weight: var(--exchanges-font-weight-bold);\n  color: var(--exchanges-color-text-muted);\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all var(--exchanges-transition-fast);\n  line-height: 1;\n  padding: 0;\n}\n\n.exchanges-filter-remove:hover {\n  color: var(--exchanges-color-error);\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.exchanges-filter-remove:active {\n  transform: scale(0.95);\n}\n\n/* Enhanced focus states */\n.exchanges-table-filter:focus + .exchanges-filter-suggestions {\n  border-color: var(--exchanges-color-accent);\n}\n\n/* Responsive adjustments for filter */\n@media (max-width: 768px) {\n  .exchanges-multi-select-filter {\n    max-width: 100%;\n  }\n  \n  .exchanges-filter-tag {\n    font-size: var(--exchanges-font-size-xs);\n    padding: 4px 6px 4px 8px;\n  }\n  \n  .exchanges-filter-remove {\n    width: 16px;\n    height: 16px;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .exchanges-selected-filters {\n    gap: 6px;\n  }\n  \n  .exchanges-filter-tag {\n    padding: 3px 5px 3px 7px;\n  }\n  \n  .exchanges-filter-remove {\n    width: 14px;\n    height: 14px;\n    font-size: 11px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
